module.exports = __webpack_public_path__ + "img/3-5.1764a970.png";